import { render, staticRenderFns } from "./OfferVideo.vue?vue&type=template&id=2fa54c03&"
import script from "./OfferVideo.vue?vue&type=script&lang=js&"
export * from "./OfferVideo.vue?vue&type=script&lang=js&"
import style0 from "./OfferVideo.vue?vue&type=style&index=0&id=2fa54c03&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports